import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    step: 1,
    form: { business_name: "", short_bio: "", category_id: null, sub_category_id: null, area: "", city: "", phone: "", website: "", logo: null, cover_image: null}
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        setStep: (state, { payload }) => {
            state.step = payload;
        },
        setForm: (state, { payload }) => {
            state.form = { ...state.form, ...payload };
        },
        resetProfile: () => initialState
    }
});

export const { setStep, setForm, resetProfile } = profileSlice.actions;
export default profileSlice.reducer;
